import { Box } from '@mui/material';
import { SearchInput } from '@ui/components';

type TranscriptionViewV2ToolbarSearchProps = {
  query: string;
  onQueryChange: (value: string) => void;
};

/**
 * Transcript search field (toolbar left cluster).
 */
export function TranscriptionSearch({
  query,
  onQueryChange,
}: TranscriptionViewV2ToolbarSearchProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mr: 2, gap: 0.5, flex: 1, minWidth: 0 }}>
      <SearchInput value={query} onSearch={onQueryChange} fullWidth />
    </Box>
  );
}
